/**
 * The DOOH page in the app's language. DOOH has English and Russian
 * (apps/dooh/engine/locales); any other language gets English, like the app.
 */
export function doohUrl(url: string, language: string | undefined) {
	const page = new URL(url);
	page.searchParams.set("lang", language?.toLowerCase().startsWith("ru") ? "ru" : "en");
	return page.href;
}
